import * as React from 'react';
import { BlogItemBase } from 'utils/contentful/blog';
import Paragraph from 'components/text/Paragraph';
import View from 'components/View';
import Heading from 'components/text/Heading';
import { useTranslation } from 'next-i18next';
import BlogCard from './BlogCard';

interface Props {
  items: Array<BlogItemBase>;
}

const Blog: React.FC<Props> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <View className="Blog">
      <Heading className="mt-6 sm:mt-16 sm:!text-4xl" variant="h2" tag="h1">
        {t('blog.blog')}
      </Heading>
      <Heading variant="h4" className="mt-1 sm:mt-3 font-semibold">
        {t('blog.allPosts')}
      </Heading>
      <div className="grid grig-cols-1 gap-y-6 sm:grid-cols-2 lg:grid-cols-3 sm:gap-x-6 sm:gap-y-16 mt-6 sm:mt-16">
        {items.map((item, i) => (
          <BlogCard key={`blog-post-${i}`} blog={item} />
        ))}
      </div>
      <Paragraph
        className="hidden sm:block pt-32 md:-mb-16 md:max-w-[480px] md:text-center m-auto font-semibold"
        variant="body3"
      >
        {t('cashback.collectCashbackAlways')}
      </Paragraph>
    </View>
  );
};

export default Blog;
